<div
  class="bg-white p-6 rounded-xl flex flex-col gap-2"
  [class.hover:cursor-pointer]="!isInEditMode()"
  (click)="handleCardClick()"
>
  <div class="flex flex-col">
    <p class="!font-bold">{{ favoriteFilter().name }}</p>
  </div>
  @if (isInEditMode()) {
  <div class="flex items-center gap-2 self-center hover:cursor-pointer" (click)="$event.stopPropagation()">
    <input
      type="checkbox"
      [attr.id]="'select-search-' + favoriteFilter().id"
      [attr.name]="'select-search-' + favoriteFilter().id"
      (change)="handleCheckboxChange()"
      class="hover:cursor-pointer"
    />
    <label [attr.for]="'select-search-' + favoriteFilter().id" class="hover:cursor-pointer"
      >{{ 'components.cardFavorite.deleteFromFavoriteText' | transloco }}</label
    >
  </div>
  } @else {
  <button
    class="cta text-vinciBlue-600 self-center"
    (click)="handleCardClick()"
  >
    {{ 'components.cardFavorite.checkTextForInternalRedirection' | transloco }}
    <icon [name]="'arrow-right'" [size]="'0.875rem'"></icon>
  </button>
  }
</div>
